// The hop from /login to /sign-up, for a visitor who turns out not to have an account yet. It has
// to carry the WorkOS Connect handle or the account they are about to create is never connected.
export function buildSignUpHref({
    redirectAfterRegister,
    externalAuthId,
}: {
    redirectAfterRegister?: string;
    externalAuthId?: string;
}): string {
    const params = new URLSearchParams();
    if (redirectAfterRegister) {
        params.set('redirectAfterRegister', redirectAfterRegister);
    }
    if (externalAuthId) {
        params.set('external_auth_id', externalAuthId);
    }

    const query = params.toString();
    return query ? `/sign-up?${query}` : '/sign-up';
}
